@import "~@govbr-ds/core/src/components/skiplink/skiplink";

:host {
  @include skiplink-configs;
}

.br-skiplink {
  &.top-left {
    left: var(--spacing-scale-3x) !important;
    right: auto !important;
  }

  &.top-center {
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%);

    &.full {
      transform: translateX(-50%) translateY(-100%);

      &.visible {
        transform: translateX(-50%) translateY(0);
      }
    }
  }

  &.top-right {
    left: auto !important;
    right: var(--spacing-scale-3x) !important;
  }

  &.visible {
    top: 0 !important;
  }

  &.full {
    br-list {
      display: flex;
      flex-direction: row;
      gap: 0;

      ::slotted(br-skiplink-item) {
        list-style: none;
      }
    }
  }

  &:not(.full) {
    min-width: var(--skiplink-min-width);
  }
}
